import { render, staticRenderFns } from "./DateRangeFilterBadge.vue?vue&type=template&id=522a7c9a&"
import script from "./DateRangeFilterBadge.vue?vue&type=script&lang=js&"
export * from "./DateRangeFilterBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports